import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to top on every route change.
 * React Router v6 doesn't do this by default, so without this users land
 * at whatever scroll position the previous page left them at — often the
 * footer or mid-page, which feels like a broken navigation.
 *
 * Honours `#hash` anchors (e.g. `/pricing#configurator`) by skipping the
 * scroll-to-top so the browser's native anchor jump can take effect.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser handle the hash-anchor
    // Defer to next paint so React has committed the new page DOM
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    });
  }, [pathname, hash]);

  return null;
}
